const removeProperties = <T extends Record<string, any>>(
  obj: T,
  startsWith: string,
): Partial<T> => {
  return Object.keys(obj).reduce<Partial<T>>((acc, key) => {
    if (!key.startsWith(startsWith)) {
      return { ...acc, [key]: obj[key] }
    }
    return acc
  }, {})
}

export default removeProperties
